// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';

const api = new APICore();

const BASE_URL = config.SHIPMENTS_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getShipmentAggregatedCost(query): any {
    const endpoint = '/service_cost_details';
    return makeApiCall(endpoint, query);
}

function getShipmentsServiceLevels(query): any {
    const endpoint = '/services_count';
    return makeApiCall(endpoint, query);
}

function getShipmentsDayServiceLevels(query): any {
    const endpoint = '/service_levels_count';
    return makeApiCall(endpoint, query);
}

function getShipmentsServiceLevelsByTimeframe(query): any {
    const endpoint = '/service_details_by_timeframe';
    return makeApiCall(endpoint, query);
}

export {
    getShipmentAggregatedCost,
    getShipmentsServiceLevels,
    getShipmentsDayServiceLevels,
    getShipmentsServiceLevelsByTimeframe,
};
